// src/pages/Login.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import GradientButton from '../components/GradientButton';

const Login = () => {
  const navigate = useNavigate();
 const [email, setEmail] = useState('');
const [password, setPassword] = useState('');
const [error, setError] = useState('');   

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user && window.location.pathname === '/login') {
      navigate('/profile');
    }
  });
  
  return () => unsubscribe();
}, [navigate]);

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  try {
    await signInWithEmailAndPassword(auth, email, password);
    navigate('/profile');
  } catch (err) {
    setError(err.message);
  }
};

  return (
    <div style={{ 
      fontFamily: "'Open Sans', sans-serif",
      backgroundColor: '#f8fafc',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header */}
<div style={{
  background: 'linear-gradient(135deg, #FFCB05 0%, #E6B800 100%)',
  borderRadius: '16px',
  padding: '2rem 1rem',
  textAlign: 'center',
  margin: '1rem',
  boxShadow: '0 8px 32px rgba(255, 203, 5, 0.3)'
}}>
        <h1 style={{
          margin: 0,
          color: '#FFF',
          fontWeight: 'bold',
          fontSize: 'clamp(2rem, 8vw, 3rem)',
          textShadow: '2px 2px rgba(0,0,0,0.2)',
          lineHeight: '1.2'
        }}>
          Welcome Back
        </h1>
        <p style={{
          color: '#FFF',
          fontSize: 'clamp(1rem, 4vw, 1.25rem)',
          margin: '0.5rem 0 0 0',
          opacity: 0.95
        }}>
          Sign in to access your account
        </p>
      </div>

      {/* Login Form Container */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem 1rem'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '2rem',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid #e5e7eb',
          width: '100%',
          maxWidth: '400px'
        }}>
          <form onSubmit={handleSubmit} style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '1rem' 
          }}>
            {error && (
              <div style={{
                padding: '0.75rem',
                backgroundColor: '#fef2f2',
                borderRadius: '8px',
                borderLeft: '4px solid #ef4444',
                color: '#dc2626',
                fontSize: '0.9rem'
              }}>
                {error}
              </div>
            )}

            <div>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '600',
                color: '#374151',
                fontSize: '0.95rem'
              }}>
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '0.875rem',
                  fontSize: '1rem',
                  borderRadius: '8px',
                  border: '2px solid #e5e7eb',
                  fontFamily: "'Open Sans', sans-serif",
                  transition: 'border-color 0.2s ease',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = '#A6CE3A'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                placeholder="Enter your account email"
              />
            </div>

            <div>
              <label style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '600',
                color: '#374151',
                fontSize: '0.95rem'
              }}>
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '0.875rem',
                  fontSize: '1rem',
                  borderRadius: '8px',
                  border: '2px solid #e5e7eb',
                  fontFamily: "'Open Sans', sans-serif",
                  transition: 'border-color 0.2s ease',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => e.target.style.borderColor = '#A6CE3A'}
                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                placeholder="Enter your password"
              />
            </div>

            <GradientButton variant="blueCompact" type="submit">
              🔓 Sign In
            </GradientButton>
          </form>

          {/* Links */}
          <div style={{
            marginTop: '2rem',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}>
            <Link 
              to="/forgot-password"
              style={{
                color: '#16a34a',
                textDecoration: 'none',
                fontSize: '1.05rem',
                fontWeight: '600',
                transition: 'color 0.2s ease'
              }}
              onMouseOver={(e) => e.target.style.color = '#8BB62A'}
              onMouseOut={(e) => e.target.style.color = '#16a34a'}
            >
              🔑 Forgot your password?
            </Link>
            
            <div style={{
              padding: '1rem',
              backgroundColor: '#f8fafc',
              borderRadius: '8px',
              fontSize: '0.95rem',
              color: '#6b7280'
            }}>
              Don't have an account?{' '}
              <Link 
                to="/signup"
                style={{
                  color: '#1E9FF2',
                  textDecoration: 'none',
                  fontWeight: '600',
                  transition: 'color 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.color = '#0EA5E9'}
                onMouseOut={(e) => e.target.style.color = '#1E9FF2'}
              >
                Sign up here
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;